var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPc === 0)?_c('div',{staticClass:"stop-wrap"},[_c('div',{staticClass:"inner-wrap"},[_c('div',{staticClass:"inner-pic"}),_vm._v(" "),_c('div',{staticClass:"inner-logo"}),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('el-button',{staticClass:"calender",on:{"click":_vm.addIcs}},[_vm._v("Add to calendar")])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5116754c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/stop.vue
// module id = null
// module chunks = 